import { render, staticRenderFns } from "./TeamChat.vue?vue&type=template&id=126da543&"
import script from "./TeamChat.vue?vue&type=script&lang=js&"
export * from "./TeamChat.vue?vue&type=script&lang=js&"
import style0 from "./TeamChat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeamChat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports